module.exports = __webpack_public_path__ + "img/normal-ticket.a89a3b0e.png";